export default __webpack_public_path__ + "static/media/Gauntlets of the Painlegion.b1b88b02.jpg";